// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  // Charge les traductions depuis le dossier public/locales/[lang]/translation.json
  .use(HttpApi)
  // Détecte la langue de l'utilisateur
  .use(LanguageDetector)
  // Passe l'instance i18n à react-i18next
  .use(initReactI18next)
  // Initialise i18next
  .init({
    // Langues supportées
    supportedLngs: ['fr', 'en'],
    // Langue par défaut si la langue détectée n'est pas supportée ou si aucune n'est détectée
    fallbackLng: 'fr',
    // Namespace par défaut (le nom de notre fichier de traduction sera translation.json)
    defaultNS: 'translation',
    // Options pour le LanguageDetector
    detection: {
      // Ordre et sources pour détecter la langue
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      // Clé à utiliser dans localStorage pour sauvegarder la langue choisie par l'utilisateur
      caches: ['localStorage'],
    },
    // Options pour HttpApi (backend)
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Chemin vers tes fichiers de traduction
    },
    // Options de React-i18next
    react: {
      useSuspense: true, // Recommandé pour charger les traductions de manière asynchrone
    },
    // Pour le débogage (affiche les clés manquantes dans la console, utile pendant le développement)
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React s'occupe déjà de la protection XSS
    },
  });

export default i18n;